import React from 'react';
import Statistics from '../components/sections/Statistics';

const StatisticsPage = () => {
    return (
        <div style={{ paddingTop: '60px' }}>
            <Statistics />
        </div>
    );
};

export default StatisticsPage;
